import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18d37935"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-group input-group-sm mb-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "search" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "input-group-text",
  id: "basic-addon2"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon bi-search" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("input", {
      type: "text",
      class: "form-control px-3",
      placeholder: "Search",
      "aria-label": "Search",
      "aria-describedby": "basic-addon2",
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('search', _ctx.handleCheck($event)))),
      value: "",
      id: "search",
      name: "search",
      disabled: ""
    }, null, 32),
    _hoisted_3
  ]))
}